import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export interface DialogData {

}
@Component({
  selector: 'app-callforword',
  templateUrl: './callforword.component.html',
  styleUrls: ['./callforword.component.css']
})
export class CallforwordComponent implements OnInit {
  public phone:string;
  public errmsg:string;
  public iserr:boolean=false;

  constructor(public dialogRef: MatDialogRef<CallforwordComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    /* for(let i = 1; i<=10 ; i++) {
      this.collection.push(i);
    } */
   }

  ngOnInit() {
  }

  Blind(){
    this.verifyNumber(this.phone, 1);
  }

  Attended(){
    this.verifyNumber(this.phone, 2);
  }

  verifyNumber(num:string, type:number)
  {
    if(num != null && num != undefined)
    {
      if(num.length == 10)
      {
        this.dialogRef.close({number:"1"+num, type:type}); 
      }
      else
      {
        this.iserr=true;
        this.errmsg = "Please Enter 10 digit Phone Number."
      }
    }
    else
    {
      this.iserr=true;
      this.errmsg = "Please Enter 10 digit Phone Number."
    }
  }

  Close(): void {
    this.dialogRef.close();
  }
}
